var _circle, _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 77,
    viewBox: "0 0 97 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5098,
    cy: 30.2559,
    r: 24,
    fill: "#EF183E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27060_4796)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.2551,
    cy: 38.2551,
    r: 34.2551,
    fill: "#FCFDFC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27060_4796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5093 65.3789L60.5098 65.3789L84.5098 41.3794L84.5093 65.3789Z",
    fill: "#001234"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5679 47.5693L41.0819 56.0553C40.7108 56.4268 40.2701 56.7215 39.785 56.9225C39.3 57.1236 38.78 57.2271 38.2549 57.2271C37.7298 57.2271 37.2099 57.1236 36.7248 56.9225C36.2397 56.7215 35.799 56.4268 35.4279 56.0553L26.9399 47.5693C24.7024 45.3316 23.1786 42.4807 22.5613 39.377C21.944 36.2733 22.2609 33.0563 23.4719 30.1327C24.6829 27.2092 26.7337 24.7104 29.3649 22.9523C31.996 21.1942 35.0894 20.2559 38.2539 20.2559C41.4184 20.2559 44.5118 21.1942 47.143 22.9523C49.7741 24.7104 51.8249 27.2092 53.0359 30.1327C54.2469 33.0563 54.5638 36.2733 53.9465 39.377C53.3292 42.4807 51.8055 45.3316 49.5679 47.5693V47.5693Z",
    stroke: "#001234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2539 36.2559C44.2539 37.8472 43.6218 39.3733 42.4965 40.4985C41.3713 41.6237 39.8452 42.2559 38.2539 42.2559C36.6626 42.2559 35.1365 41.6237 34.0113 40.4985C32.886 39.3733 32.2539 37.8472 32.2539 36.2559C32.2539 34.6646 32.886 33.1384 34.0113 32.0132C35.1365 30.888 36.6626 30.2559 38.2539 30.2559C39.8452 30.2559 41.3713 30.888 42.4965 32.0132C43.6218 33.1384 44.2539 34.6646 44.2539 36.2559V36.2559Z",
    stroke: "#001234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27060_4796",
    x: 0,
    y: 0,
    width: 76.5098,
    height: 76.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27060_4796",
    x: 56.5098,
    y: 37.3789,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4796"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d172acc17f3ae35e00a6dfdcc471da21.svg";
export { ForwardRef as ReactComponent };